import axios from 'axios';
import returnDomenLocation from '../helpers/returnDomainLoc';

const config = () => ({
  baseURL: returnDomenLocation('cms-api'),
});

export default axios.create(config());
